export enum InputMaxLengthEnum {
  userFirstName = 50,
  userLastName = 50,
  savedSearchName = 64,
  tagName = 32,
  folderName = 30,
  folderDesc = 240,
  statusName = 30
}
